import { render, staticRenderFns } from "./similarProducts.vue?vue&type=template&id=0b2b7d41&scoped=true&"
import script from "./similarProducts.vue?vue&type=script&lang=js&"
export * from "./similarProducts.vue?vue&type=script&lang=js&"
import style0 from "./similarProducts.vue?vue&type=style&index=0&id=0b2b7d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b7d41",
  null
  
)

export default component.exports